// Japanese
export const ja = {
  'app.name':           'Kardolive',
  'app.tagline':        'カスタマーポータル',
  'app.signOut':        'サインアウト',

  'login.email':        'メールアドレス',
  'login.password':     'パスワード',
  'login.signIn':       'サインイン',
  'login.signingIn':    'サインイン中…',
  'login.failed':       'サインインに失敗しました',
  'login.newAccount':   'Kardoliveは初めてですか?',
  'login.createAccount':'無料アカウントを作成 →',

  'nav.workspace':      'ワークスペース',
  'nav.templates':      'テンプレート',
  'nav.live':           'ライブ',
  'nav.rooms':          'ルームとチャット',
  'nav.content':        'コンテンツ',
  'nav.developer':      '開発者',
  'nav.account':        'アカウント',

  'nav.overview':       '概要',
  'nav.projects':       'プロジェクト',
  'nav.chat':           'チャットコンソール',
  'nav.sessions':       'セッション',
  'nav.streams':        'ライブ配信',
  'nav.studio':         'スタジオ',
  'nav.recordings':     '録画',
  'nav.apiKeys':        'APIキー',
  'nav.webhooks':       'Webhook',
  'nav.webhookTester':  'Webhookテスター',
  'nav.networkTest':    'ネットワークテスト',
  'nav.embed':          '埋め込みウィジェット',
  'nav.sdk':            'SDKとドキュメント',
  'nav.docs':           '開発者ドキュメント',
  'nav.analytics':      '分析',
  'nav.settings':       '設定',

  'overview.welcome':       'おかえりなさい、{name}',
  'overview.plan':          '{tenant} · {plan} プラン',
  'overview.newStream':     '新しい配信',
  'overview.kpi.live':           'ライブ中',
  'overview.kpi.live.broadcasting': '配信中',
  'overview.kpi.live.nothing':    'ライブなし',
  'overview.kpi.total':           '配信合計',
  'overview.kpi.total.sub':       '全期間',
  'overview.kpi.sessions':        'セッション · 30日',
  'overview.kpi.sessions.sub':    '公開イベント',
  'overview.kpi.recordings':      '録画',
  'overview.kpi.recordings.sub':  '再生可能',
  'overview.recentStreams':       '最近の配信',
  'overview.recentSessions':      '最近のセッション',
  'overview.viewAll':             'すべて表示 →',
  'overview.empty.title':         'まだ配信がありません',
  'overview.empty.body':          '最初の配信を作成して放送を開始しましょう。',
  'overview.empty.action':        '配信を作成',
  'overview.noSessions':          'まだセッションがありません',

  'status.live':        'ライブ',
  'status.idle':        '待機中',
  'status.ended':       '終了',
  'status.archived':    'アーカイブ済み',

  'common.save':        '保存',
  'common.cancel':      'キャンセル',
  'common.delete':      '削除',
  'common.edit':        '編集',
  'common.create':      '作成',
  'common.confirm':     '確認',
  'common.loading':     '読み込み中…',
  'common.error':       'エラー',
  'common.retry':       '再試行',

  // Dashboard navigation and account controls.
  "nav.skipContent": "ページの内容へ移動",
  "nav.streamTemplates": "配信テンプレート",
  "nav.boards": "インタラクティブボード",
  "nav.menu": "ナビゲーションを開く",
  "nav.closeMenu": "ナビゲーションを閉じる",
  "nav.scenarios": "利用シナリオ",
  "nav.premieres": "プレミア公開",
  "nav.clips": "クリップ",
  "dashboard.account": "アカウント",
  "dashboard.language": "言語",
  "dashboard.appearance": "外観",
  "nav.allStreams": "すべての配信",
  "nav.destinations": "配信先",
  "nav.ecommerce": "Eコマース",
  "nav.products": "商品",
  "nav.services": "サービス",
  "nav.collections": "コレクション",
  "nav.orders": "注文",
  "nav.commerceSettings": "コマース設定",
  "nav.engagement": "交流",
  "theme.light": "ライトモードに切り替え",
  "theme.dark": "ダークモードに切り替え",
  "role.owner": "オーナー",
  "role.admin": "管理者",
  "role.member": "メンバー",
  "role.viewer": "閲覧者",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "利用中",
  "streams.archived": "アーカイブ済み",
  "streams.monitor": "配信元モニター",
  "streams.create": "ライブ配信を作成",
  "streams.list": "リスト",
  "streams.grid": "グリッド",
  "streams.view": "配信の表示方法",
  "streams.searchLabel": "イベントを検索",
  "streams.searchHint": "イベント名で検索",
  "streams.solutionFilter": "配信タイプで絞り込む",
  "streams.statusFilter": "状態で絞り込む",
  "streams.dateFilter": "作成日で絞り込む",
  "streams.allSolutions": "すべてのタイプ",
  "streams.custom": "既存・カスタム設定",
  "streams.allStatuses": "すべての状態",
  "streams.anyTime": "作成日の指定なし",
  "streams.last7": "過去7日間に作成",
  "streams.last30": "過去30日間に作成",
  "streams.count": "{total}件中{shown}件のイベントを表示",
  "streams.noMatch": "条件に一致するイベントはありません。",
  "streams.clearFilters": "絞り込みを解除",
  "streams.refreshFailed": "配信一覧を更新できませんでした",
  "streams.loadFailed": "配信を読み込めませんでした",
  "streams.stale": "前回読み込んだ一覧を表示しています。状態が変わっている可能性があります。",
  "streams.connectionHint": "接続を確認して、一覧を再読み込みしてください。",
  "streams.retrying": "再試行中…",
  "streams.retry": "再試行",
  "streams.restoreFailed": "配信を復元できませんでした",
  "streams.restoreHint": "再試行する前に、接続を確認して一覧を更新し、最新の状態を確認してください。",
  "streams.unused": "未使用の配信：{count}件",
  "streams.unusedHint": "配信履歴やリプレイはありません。アーカイブして一覧を整理できます。内容は削除されません。",
  "streams.reviewArchive": "確認してアーカイブ",
  "streams.loading": "配信を読み込み中…",
  "streams.archiveEmpty": "アーカイブはありません。アーカイブした配信とリプレイは、復元するまでここに保存されます。",
  "streams.restore": "復元",
  "streams.firstTitle": "最初の配信を作成しましょう",
  "streams.firstBody": "販売、授業、サービス向けの設定を選ぶか、空の配信から始めましょう。ブラウザー、スマートフォン、OBSから配信できます。",
  "streams.blank": "空の配信",
  "streams.broadcasts": "配信回数：{count}",
  "streams.replays": "リプレイ：{count}件",
  "streams.sessions": "セッション：{count}件",
  "streams.recordings": "録画：{count}件",
  "streams.mode.BROADCAST": "ブロードキャスト",
  "streams.mode.LOW_LATENCY": "低遅延",
  "streams.mode.REALTIME": "リアルタイム",
  "streams.key": "キー",
  "streams.archiveTitle": "未使用の配信をアーカイブ",
  "streams.archiveHint": "これらの配信はまだ開始されていません。「アーカイブ済み」からいつでも復元できます。",
  "streams.archiveFailed": "{count}件をアーカイブできませんでした。配信が始まった可能性があります。それ以外はアーカイブ済みです。",
  "streams.archiving": "アーカイブ中…",
  "streams.archiveCount": "{count}件をアーカイブ",
  "streamType.webinar": "ビジネスウェビナー・発表会",
  "streamType.classroom": "授業・個別指導",
  "streamType.training": "企業研修",
  "streamType.conference": "会議・展示会",
  "streamType.shopping": "ライブショッピング",
  "streamType.auction": "ライブオークション",
  "streamType.consultation": "個別相談",
  "streamType.creator": "クリエイター・コミュニティ配信",
  "streamType.audio": "音声ルーム・ポッドキャスト",
  "streamType.sports": "スポーツ・eスポーツ",
  "streamType.performance": "コンサート・公演",
  "streamType.community": "礼拝・募金活動",
  "streamType.tour": "ツアー・実演",
  "streamType.fitness": "フィットネス・ワークショップ",
  "streamType.public-meeting": "ニュース・公開会議",
  "streamType.continuous": "常時配信チャンネル・カメラ",
  "streams.close": "閉じる",
};
